
import React from 'react';
import Hero from './Homepage/Hero';
import ThinkFinance from './Homepage/ThinkFinance';
import ThinkHR from './Homepage/ThinkHR';
import MarketResearch from './Homepage/MarketResearch';
import TAAS from './Homepage/TAAS';
import ProductsGrid from './Homepage/ProductsGrid';

const Home = () => {
  return (
    <>
      <Hero />
      <ThinkFinance />
      <ThinkHR />
      <MarketResearch />
      <TAAS />
        <ProductsGrid />
      
    </>
  );
};

export default Home;